// src/features/commission/components/CommissionCustomerCard.tsx
import { Card } from '../../../app/components/foundation';
import type { Commission } from '../types/commission.types';

export interface CommissionCustomerCardProps {
  commission: Commission;
}

/**
 * Workspace card: which customer this commission was earned on.
 * Pulls customerName/customerId straight off the base Commission
 * record — same self-contained approach as
 * orders/components/OrderCustomerCard.tsx, this feature does not
 * import from features/customers.
 */
export function CommissionCustomerCard({ commission }: CommissionCustomerCardProps) {
  return (
    <Card className="vania-commission-workspace-card">
      <h2 className="vania-commission-workspace-card-title">نماینده</h2>

      <dl className="vania-commission-workspace-fieldlist">
        <div>
          <dt>نام نماینده</dt>
          <dd>{commission.representative_name || '-'}</dd>
        </div>
        <div>
          <dt>موبایل</dt>
          <dd dir="ltr">{commission.mobile || '-'}</dd>
        </div>
      </dl>
    </Card>
  );
}
